import { Component, OnInit, inject, DestroyRef, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidebarSuperAdmin } from '@shared/bases/sidebar-super-admin/sidebar-super-admin';
import { Header } from '@shared/bases/header/header';
import { BottomNav } from '@shared/bases/bottom-nav/bottom-nav';
import { Footer } from '@shared/bases/footer/footer';

@Component({
  selector: 'app-super-admin-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, SidebarSuperAdmin, Header, BottomNav, Footer],
  templateUrl: './super-admin-layout.html',
  styleUrl: './super-admin-layout.css',
})
export class SuperAdminLayout implements OnInit {
  private breakpointObserver = inject(BreakpointObserver);
  private destroyRef = inject(DestroyRef);

  isSidebarOpen = signal<boolean>(typeof window !== 'undefined' ? window.innerWidth >= 1024 : false);

  ngOnInit() {
    this.breakpointObserver
      .observe(['(min-width: 1024px)'])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        this.isSidebarOpen.set(result.matches);
      });
  }

  toggleSidebar() {
    this.isSidebarOpen.update(v => !v);
  }
}
